import React from "react"
import { Layer, Source } from "react-mapbox-gl"
import { connect } from "react-redux"
import { layersSelectors } from "../../../../../../state/layers"
import { MapStyleProperties } from "../../../../../../utils/mapbox/mapStyleProperties"
import mapboxPresentationProperties from "../../../../../utils/mapboxPresentationProperties"

const mapStateToProps = (state) => ({
  hotelFeatures: layersSelectors.selectHotelAverageDailyRateFeatures(state),
})

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

const HOTEL_AVERAGE_DAILY_RATE_SOURCE_ID = "hotel-average-daily-rate-source"

const LAYER_FILL_PAINT = {
  "fill-opacity": 0.5,
  "fill-color": [
    "interpolate",
    ["linear"],
    [
      "get",
      MapStyleProperties.RentFeatureFieldId.Value
    ],
    50,
    "#fd0d0d",
    100,
    "#fff305",
    200,
    "#0fe600",
    300,
    "#16e7fe",
    500,
    "#024be8",
  ]
}

class HotelAverageDailyRateFeatureLayer extends React.PureComponent<Props, {}> {
  render() {
    return (
      <>
        <Source
          id={HOTEL_AVERAGE_DAILY_RATE_SOURCE_ID}
          geoJsonSource={{
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features: this.props.hotelFeatures
            }
          }}
        />
        <Layer
          id={MapStyleProperties.LayerId.HotelAverageDailyRateFill}
          type={MapStyleProperties.LayerType.Fill}
          sourceId={HOTEL_AVERAGE_DAILY_RATE_SOURCE_ID}
          paint={LAYER_FILL_PAINT}
          before={MapStyleProperties.LayerId.UsaBuildings}
        />
        <Layer
          id={MapStyleProperties.LayerId.HotelAverageDailyRateBorder}
          type={MapStyleProperties.LayerType.Line}
          sourceId={HOTEL_AVERAGE_DAILY_RATE_SOURCE_ID}
          paint={mapboxPresentationProperties.rentLayersLinePaint}
          before={MapStyleProperties.LayerId.UsaBuildings}
        />
        <Layer
          id={MapStyleProperties.LayerId.HotelAverageDailyRateSymbol}
          type={MapStyleProperties.LayerType.Symbol}
          sourceId={HOTEL_AVERAGE_DAILY_RATE_SOURCE_ID}
          layout={mapboxPresentationProperties.rentLabelsSymbolLayout(MapStyleProperties.RentFeatureFieldId.Value, { prefix: "$" })}
          paint={mapboxPresentationProperties.rentLayersSymbolPaint}
          minZoom={13}
          before={MapStyleProperties.LayerId.UsaBuildings}
        />
      </>
    )
  }
}

export default connect(
  mapStateToProps
)(HotelAverageDailyRateFeatureLayer);
